import { DataTableCol } from "../../../components/data-table/types";

export const RetailerInvoicesGridCols: DataTableCol[] = [
    {
        title: 'Invoice Number',
        control: 'invoice_number',
        sortable: false,
        canShowColumn: true
    },
    {
        title: 'Date',
        control: 'Date',
        sortable: false,
        canShowColumn: true
    },
    {
        title: 'Name',
        control: 'name',
        sortable: false,
        canShowColumn: true
    },
    {
        title: 'Phone Number',
        control: 'contact',
        sortable: false,
        canShowColumn: true
    },
    {
        title: 'Paid Amount',
        control: 'paid_amount',
        sortable: false,
        canShowColumn: true
    },
    {
        title: 'Pending Amount',
        control: 'pending_amount',
        sortable: false,
        canShowColumn: true
    },
    {
        title: 'Actions',
        control: 'actions',
        sortable: false,
        isView:true,
        canShowColumn: true   
    }
]